import {useAuth} from "../../providers/authprovider";
import React, {useEffect, useState} from "react";
import {Alert, Button, Form, Modal, Table} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";
import useAlert from "../../components/CustomAlert";
import {usePrivilege} from "../../providers/privilegeprovider";

export default function Notes(props){

    const {getPrivilege} = usePrivilege();
    const privilege = getPrivilege('buildings')
    const {id, name} = props.building;
    const {showAlert,
        hideAlert,
        alert} = useAlert()
    const {notes : {get, remove}, user} = useAuth();
    const [downloaded, setDownloaded] = useState(false)
    const [notes, setNotes] = useState([]);
    const [editNote, setEditNote] = useState(undefined)
    const handleClose = props.onHide;


    useEffect(()=>{
        if(downloaded)
            return;

        get(id, response=>{
            setDownloaded(true);

            if(response.success)
                setNotes(response.content);
        })

    })

    const handleNoteSaved = (note)=>{
        const existingIndex = notes.findIndex(c=>c.id === note.id)
        if(existingIndex > -1)
            notes.splice(existingIndex, 1, note);
        else
            notes.unshift(note);

        setEditNote(undefined)
        setNotes([...notes]);
    }

    const handleDeleteNote = (event, noteId)=>{
        event.stopPropagation();

        if(!window.confirm("Potwierdź usunięcie notatki z historii. Usunięcie jest trwałe i nie może zostać cofnięte."))
            return;

        hideAlert();

        remove(noteId, ({success, error, content})=>{


            if(!success)
                return showAlert(error);

            const existingIndex = notes.findIndex(c=>c.id === content.id)
            if(existingIndex < 0)
                return;

            notes.splice(existingIndex, 1);
            setEditNote(undefined)
            setNotes([...notes]);
        });
    }


    return (
        <Modal size={"lg"} {...props} show={true} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {alert()}
                {
                    privilege?.edit &&
                    <AddNoteForm buildingId={id} note={editNote} onSave={handleNoteSaved} />
                }

                {
                    downloaded ?
                        <Table hover >
                            <thead>
                            <tr>
                                <th>Notatka</th>
                                <th>Data i godzina</th>
                                <th>Użytkownik</th>
                                {
                                    user.isAdmin &&
                                    <th>Kasuj</th>
                                }
                            </tr>
                            </thead>
                            <tbody>
                            {
                                notes.map(note=> {

                                        const date = note.created_at.slice(0, 10);
                                        const time = note.created_at.slice(11,19);

                                        return (
                                            <tr className={"cursor-pointer"} key={note.id} onClick={()=>setEditNote(note)}>
                                                <td><div style={{whiteSpace:"pre-wrap"}}>{note.value}</div></td>
                                                <td>{time} {date}</td>
                                                <td>{note.name}</td>
                                                {
                                                    user.isAdmin &&
                                                    <th><Button className={"btn-close"} onClick={(e)=>handleDeleteNote(e, note.id)} /> </th>
                                                }
                                            </tr>
                                        )
                                    }
                                )
                            }
                            </tbody>
                        </Table>
                        :
                        <div>
                            <FontAwesomeIcon icon={faSpinner} spin={true} />
                            Pobieranie danych...
                        </div>
                }

            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Zamknij
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

function AddNoteForm(props){
    const buildingId = props.buildingId;
    const {notes : {add}} = useAuth();
    const [disabled, setDisabled] = useState(false);
    const [note, setNote] = useState({value:"", foreign_id:buildingId});
    const [alert, setAlert] = useState({show:false, content: "",});
    const hideAlert = ()=>{ setAlert({show:false, content: ""})};
    const addAlert = (content)=>setAlert({show:true, content:content});

    useEffect(()=>{
        if(props.note === undefined)
            setNote({value:"", foreign_id:buildingId})
        else
            setNote(props.note)
        // console.log("set current note to ", props.note)
    }, [props.note])


    const handleSave = ()=>{
        if(note.value.trim().length <= 0)
            return addAlert("Wprowadź treść notatki");

        setDisabled(true)

        add(note, false, (response)=>{
            setDisabled(false)

            if(response.success) {
                setNote({...note, value: ""})
                return props.onSave(response.content);
            }
            addAlert(response.error);
        })
    }

    const handleSetNote = (event)=>{
        setNote({...note, value:event.target.value});
    }


    return (
        <div >
            <h6>Dodaj do historii</h6>
            <Form.Group className="p-3" controlId="note">
                <Alert show={alert.show} variant={"warning"} onClose={hideAlert} dismissible>
                    <p>
                        {alert.content}
                    </p>
                </Alert>
                <Form.Control
                    value={note.value}
                    onChange={handleSetNote}
                    type="text"
                    as={"textarea"}
                    rows={5}
                    placeholder="wprowadź treść notatki"

                />
                <div className={"p-2"}>
                    {
                        disabled  ?
                            <Button variant={"primary"} ><FontAwesomeIcon icon={faSpinner} spin={true} /></Button>
                            :
                            <Button variant={"primary"} onClick={handleSave}>Zapisz</Button>
                    }
                </div>

            </Form.Group>
        </div>

    )
}